// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3lDxZ","title":"AfterImages45_title__3uQnR","images":"AfterImages45_images__1L2Ce"};